import { render } from "./portal-ongoing-system.vue?vue&type=template&id=72e55652"
import script from "./portal-ongoing-system.vue?vue&type=script&lang=js"
export * from "./portal-ongoing-system.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__